<template>
  <one-breadcrumb
    v-if="canViewMenu"
    :key="breadcrumbKey"
    separator=">"
    :accessibility-label="accessibilityLabel"
  >
    <one-breadcrumb-item
      v-for="(route, index) in matchedRoutes"
      :key="`breadcrumb-${route.meta.breadcrumbTextKey}`"
      :to="{ name: route.name, params: filterParamsForRoute(route, $route.params) }"
      :is-clickable="index < matchedRoutes.length - 1"
    >
      {{ route.meta.compoundBreadcrumb }}
    </one-breadcrumb-item>
  </one-breadcrumb>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MainBreadcrumbs',
  props: {
    accessibilityLabel: {
      type: String,
      default: 'Breadcrumb navigation'
    }
  },
  computed: {
    ...mapGetters(['canViewMenu'])
  },
  data () {
    return {
      matchedRoutes: [],
      breadcrumbKey: 0
    }
  },
  watch: {
    $route: {
      handler () {
        this.routesHandler()
      },
      immediate: true
    },
    '$i18n.locale': {
      handler () {
        this.routesHandler()
      }
    }
  },
  methods: {
    filterParamsForRoute (route, params) {
      // Los params válidos son los definidos en route.path (e.g. ':id', ':invoiceId', etc.)
      const validKeys = route.path.split('/').filter(p => p.startsWith(':')).map(p => p.slice(1))
      // Devuelve solo los params válidos
      return Object.fromEntries(validKeys.filter(k => params[k] !== undefined).map(k => [k, params[k]]))
    },
    routesHandler () {
      this.matchedRoutes = this.$route.matched
        .filter(e => e.meta.breadcrumbTextKey || e.meta.breadcrumbParam)
        .map(e => this.setBreadcrumb(e))
      this.breadcrumbKey++
    },
    setBreadcrumb (route) {
      if (route.meta.breadcrumbParam && route.meta.breadcrumbTextKey) {
        route.meta.compoundBreadcrumb =
          this.$t('breadcrumb.' + route.meta.breadcrumbTextKey) +
          this.$route.params[route.meta.breadcrumbParam]
      } else if (route.meta.breadcrumbParam) {
        route.meta.compoundBreadcrumb = this.$route.params[route.meta.breadcrumbParam]
      } else {
        route.meta.compoundBreadcrumb = this.$t('breadcrumb.' + route.meta.breadcrumbTextKey)
      }
      return route
    }
  }
}
</script>
